import React, { useEffect, useState } from "react";
import API from "../api";
import Sidebar from "./Sidebar";
import TopBar from "../components/TopBar";

const AdminProfile = () => {
    const [user, setUser] = useState({});
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [avatar, setAvatar] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const [popup, setPopup] = useState({ show: false, message: "", type: "" });
    const [showImageModal, setShowImageModal] = useState(false);

    const showPopup = (message, type = "success") => {
        setPopup({ show: true, message, type });
        setTimeout(() => setPopup({ show: false, message: "", type: "" }), 3000);
    };

    // FETCH PROFILE
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const { data } = await API.get("/profile");
                setUser(data);
                setName(data.name);
                setEmail(data.email);
            } catch (err) {
                showPopup("Failed to load profile", "danger");
            }
        };
        fetchProfile();
    }, []);

    // UPDATE PROFILE
    const updateProfile = async (e) => {
        e.preventDefault();
        try {
            await API.put("/profile", { name, email });
            showPopup("Profile updated successfully");
        } catch (err) {
            showPopup(err.response?.data?.message || "Update failed", "danger");
        }
    };

    // CHANGE PASSWORD
    const changePassword = async () => {
        try {
            await API.put("/profile/password", { currentPassword, newPassword });
            setCurrentPassword("");
            setNewPassword("");
            showPopup("Password changed successfully");
        } catch (err) {
            showPopup(err.response?.data?.message || "Password change failed", "danger");
        }
    };

    // UPLOAD AVATAR
    const uploadAvatar = async () => {
        const formData = new FormData();
        formData.append("avatar", avatar);

        try {
            await API.put("/profile/avatar", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            showPopup("Avatar updated");
            window.location.reload();
        } catch (err) {
            showPopup("Upload failed", "danger");
        }
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh", background: "#f4f6f9" }}>
            <Sidebar setIsSidebarOpen={setIsSidebarOpen} />

            <div
                style={{
                    flex: 1,
                    marginLeft: isSidebarOpen ? "250px" : "80px",
                    transition: "0.3s",
                    padding: "20px"
                }}
            >
                <TopBar />

                {/* POPUP MESSAGE */}
                {popup.show && (
                    <div
                        className={`alert alert-${popup.type} position-fixed top-0 end-0 m-4 shadow`}
                        style={{ zIndex: 1055, minWidth: "250px" }}
                    >
                        {popup.message}
                    </div>
                )}

                <div className="container-fluid mt-4">
                    <div className="row g-4">
                        {/* LEFT CARD */}
                        <div className="col-lg-4">
                            <div className="card shadow border-0 text-center p-4">
                                <img
                                    src={
                                        user.avatar
                                            ? `${process.env.REACT_APP_API_URL}/uploads/${user.avatar}`
                                            : "/default-avatar.png"
                                    }
                                    alt="avatar"
                                    onClick={() => setShowImageModal(true)}
                                    style={{
                                        width: "130px",
                                        height: "130px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                        aspectRatio: "1/1",
                                        cursor: "pointer",
                                        border: "4px solid #fff",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                                    }}
                                    className="mx-auto mb-3"
                                />
                                <h5 className="fw-bold">{user.name}</h5>
                                <p className="text-muted small">{user.email}</p>

                                <input
                                    type="file"
                                    className="form-control mt-3"
                                    onChange={(e) => setAvatar(e.target.files[0])}
                                />
                                <button className="btn btn-dark mt-2 w-100" onClick={uploadAvatar}>
                                    Update Avatar
                                </button>
                            </div>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="col-lg-8">
                            <div className="card shadow border-0 p-4 mb-4">
                                <h5 className="mb-3">Edit Information</h5>
                                <form onSubmit={updateProfile}>
                                    <input
                                        className="form-control mb-3"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Full Name"
                                    />
                                    <input
                                        className="form-control mb-3"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Email Address"
                                    />
                                    <button className="btn btn-primary w-100">Save Changes</button>
                                </form>
                            </div>

                            <div className="card shadow border-0 p-4">
                                <h5 className="mb-3">Change Password</h5>
                                <input
                                    type="password"
                                    className="form-control mb-3"
                                    placeholder="Current Password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                <input
                                    type="password"
                                    className="form-control mb-3"
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <button className="btn btn-warning w-100" onClick={changePassword}>
                                    Update Password
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* IMAGE PREVIEW MODAL */}
            {showImageModal && (
                <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.7)" }}>
                    <div className="modal-dialog modal-md modal-dialog-centered">
                        <div className="modal-content border-0 shadow position-relative p-3">

                            {/* CLOSE ICON */}
                            <span
                                onClick={() => setShowImageModal(false)}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "15px",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    color: "#333"
                                }}
                            >
                                &times;
                            </span>

                            <img
                                src={
                                    user.avatar
                                        ? `${process.env.REACT_APP_API_URL}/uploads/${user.avatar}`
                                        : "/default-avatar.png"
                                }
                                alt="preview"
                                className="img-fluid rounded"
                                style={{ maxHeight: "500px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default AdminProfile;
